<template>
	<div class="thank-tile">
		<div class="img">
			<img
				v-if="institution"
				v-bind:src="institution.logo_url"
				v-bind:style="{ width: '100px', height: '100px' }"
			/>
		</div>
		<div class="thank-text">
			<slot name="org"></slot>
			<slot name="text"></slot>
		</div>
	</div>
</template>

<script>
export default {
	name: 'thank-tile',
	props: {
		institution: Object
	},
	data() {
		return {
			isSaving: false
		}
	}
}
</script>

<style lang="scss">
.thank-tile {
	width: 100%;
	text-align: center;
	padding: 0 20px 5px;
	.thank-text {
		font-family: Bitter, serif;
		color: $dark-grey;
		font-weight: 400;
		-webkit-font-smoothing: antialiased;
	}
	.thank-encouragement {
		text-transform: uppercase;
		color: $dark-grey;
		font-weight: 600;
		opacity: 0.5;
	}
	.img {
		height: 100px;
		width: 100px;
		background: #fff;
		margin-top: 15px;
		margin-bottom: 25px;
		margin-left: auto;
		margin-right: auto;
	}
}
</style>
